import { Injectable } from '@angular/core';
import { ImportHistory } from '../model/import-history';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { ImportHistoryResponse } from '../model/import-history-response';
import { MappingProduct } from '../model/mappingProduct';


@Injectable({
  providedIn: 'root'
})
export class ImportService {

  constructor(private readonly http: HttpClient) {}

  getImportsHistory(data): Observable<ImportHistoryResponse> {
    return this.http.post<ImportHistoryResponse>(environment.api_url + 'history/imports', data);
  }

  getImportHistory(importId: string): Observable<ImportHistory> {
    let params = new HttpParams().set('importId', importId);
    return this.http.get<ImportHistory>(environment.api_url + 'history/import', { params });
  }

  getImportMapping(fileId) {
    let params= new HttpParams().set('importId', fileId);
    return this.http.get(environment.api_url + 'mapping/categories', { params });
  }

  exportImportHistory(data) {
    return this.http.post(`${environment.api_url}export/imports/history`, data, { responseType: 'blob', observe: 'response' })
  }

  getMappingProducts(importId, shopCode) : Observable<MappingProduct>{
    let params= new HttpParams().set('importId', importId).append('shopCode', shopCode);
    return this.http.get<MappingProduct>(environment.api_url + 'mapping/products', { params });
  }
}
